var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDown9 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 58,
  height: 22,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#down9_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#down9_svg__b)",
  d: "M0 14.647c3.867-4.282 7.733-8.564 11.6-10.875s7.733-2.65 11.6.725 7.733 10.464 11.6 10.392 7.733-7.305 11.6-8.7S54.133 9.237 58 13.68v8.7H0z",
  opacity: 0.1,
  style: {
    mixBlendMode: "multiply"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#D72C0D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M0 14.647c3.867-4.282 7.733-8.564 11.6-10.875s7.733-2.65 11.6.725 7.733 10.464 11.6 10.392 7.733-7.305 11.6-8.7S54.133 9.237 58 13.68"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "down9_svg__b",
  x1: 38.999,
  x2: 38.999,
  y1: 3.39,
  y2: 22.38,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FA836D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FA836D",
  stopOpacity: 0.09
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "down9_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h58v22H0z"
})))));
export { SvgDown9 as ReactComponent };
export default __webpack_public_path__ + "static/media/down9.50178b1d.svg";